import {
  addMinutes,
  addYears,
  format,
  formatDuration,
  intervalToDuration,
  subYears,
} from 'date-fns';

export const CALENDAR_START_MONTH = subYears(new Date(), 5);
export const CALENDAR_END_MONTH = addYears(new Date(), 5);

export const shortenDurationString = (duration: string) =>
  duration.replace(/ hours?/, ' hr').replace(/ minutes?/, ' min');

export const minutesToDuration = (minutes: number) => {
  const start = new Date(0);
  const end = addMinutes(start, minutes);

  const duration = intervalToDuration({ start, end });

  return shortenDurationString(
    formatDuration(duration, { format: ['hours', 'minutes'], delimiter: ' ' })
  );
};

export const isDateValid = (date: Date) => !Number.isNaN(date.getTime());

export const toInputDate = (value?: string | null) => {
  if (!value) return '';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  return format(date, 'yyyy-MM-dd');
};

export const toDateOrNull = (value?: string | Date | null): Date | null => {
  if (!value) return null;

  const date = value instanceof Date ? value : new Date(value);

  return isDateValid(date) ? date : null;
};

export const toISODateOrNull = (value?: string | Date | null) =>
  toDateOrNull(value)?.toISOString() ?? null;
